const questions = [
  {
    id: 1,
    title:
      "What is the relationship between Microsoft and Amazon Web Services?",
    info:
      "Amazon Web Services and Microsoft have worked together for several years, starting with AWS launching Windows Server based instances in 2008. AWS is a Gold Certified member of the Microsoft Partner Network and licensed to sell Microsoft software under the Services Provider License Agreement (SPLA). AWS is also an authorized license mobility partner. Over the years, AWS and Microsoft have collaborated to make Windows and its associated workloads available in the AWS cloud. Microsoft and AWS have mutual customers running Windows workloads on AWS today, including Dole Foods, Hess Corporation, and Lionsgate. "
  },
  {
    id: 2,
    title: "Is Microsoft software supported on AWS?",
    info:
      "Yes. AWS Support has been successfully supporting our customers who run Microsoft Windows-based EC2 instances in the AWS cloud since 2008 when we first launched Windows Server on EC2."
  },
  {
    id: 3,
    title:
      "Can AWS open a support case with Microsoft on issues I might encounter?",
    info:
      "Yes, AWS Support can work directly with Microsoft support engineers to escalate a support case if necessary to resolve issues encountered by AWS Support customers at the Business or Enterprise tier. AWS will not share any Customer information or specific details without your permission."
  },
  {
    id: 4,
    title: "What types of Microsoft software can I run on AWS?",
    info:
      "You can run many types of Microsoft software on AWS, including but not limited to: Microsoft Office, Windows Server, SQL Server, Exchange, SharePoint"
  },
  {
    id: 5,
    title: "How does AWS work with Microsoft to resolve customer issues?",
    info:
      "Customers who subscribe to AWS Support at the Business or Enterprise tier can submit issues through the AWS Support Center console. If the AWS Support Engineer finds that the problem is due to a Microsoft product or driver, the AWS Support Engineer can file a case with Microsoft and proceed with joint troubleshooting."
  }
];
export default questions;
